import { FieldValue, Timestamp } from "firebase/firestore";

export const isLiveFirestoreSentinel = (value) =>
  value instanceof FieldValue || value?._delegate instanceof FieldValue;

export const isFirestoreSentinel = (value) => Boolean(
  value && typeof value === "object" && (
    isLiveFirestoreSentinel(value) ||
    typeof value._methodName === "string" ||
    typeof value.methodName === "string"
  )
);

function readDateMillis(value) {
  if (value == null || value === "" || isFirestoreSentinel(value)) return NaN;
  try {
    let millis;
    if (typeof value.toMillis === "function") millis = value.toMillis();
    else if (typeof value.toDate === "function") millis = value.toDate().getTime();
    else if (value instanceof Date) millis = value.getTime();
    else if (typeof value === "string" || typeof value === "number") millis = new Date(value).getTime();
    else if (typeof value === "object" && (value.seconds != null || value._seconds != null)) {
      millis = Number(value.seconds ?? value._seconds) * 1000 +
        Number(value.nanoseconds ?? value._nanoseconds ?? 0) / 1000000;
    }
    return Number.isFinite(millis) ? millis : NaN;
  } catch {
    return NaN;
  }
}

export function toSortableMillis(value) {
  const millis = readDateMillis(value);
  return Number.isFinite(millis) ? millis : 0;
}

export function normalizeIndexDateForWrite(value, fallback = null) {
  for (const candidate of [value, ...[].concat(fallback)]) {
    const millis = readDateMillis(candidate);
    if (!Number.isFinite(millis)) continue;
    try { return Timestamp.fromMillis(millis); } catch { /* Try the next historical source. */ }
  }
  return null;
}

export function stripFirestoreSentinelsForState(value, seen = new WeakSet()) {
  if (isFirestoreSentinel(value) || typeof value === "undefined") return undefined;
  if (value == null || typeof value !== "object" || value instanceof Date ||
      typeof value.toDate === "function" || typeof value.toMillis === "function") return value;
  if (seen.has(value)) return undefined;
  seen.add(value);
  const result = Array.isArray(value)
    ? value.map(entry => stripFirestoreSentinelsForState(entry, seen) ?? null)
    : Object.fromEntries(Object.entries(value).map(([key, entry]) =>
      [key, stripFirestoreSentinelsForState(entry, seen)]).filter(([, entry]) => entry !== undefined));
  seen.delete(value);
  return result;
}
